import { render, staticRenderFns } from "./DiscoveryTableSingleAdd.vue?vue&type=template&id=640581b0&scoped=true&"
import script from "./DiscoveryTableSingleAdd.vue?vue&type=script&lang=js&"
export * from "./DiscoveryTableSingleAdd.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "640581b0",
  null
  
)

export default component.exports